import { cn } from '@/app/_lib/utils';
import type { ReactNode } from 'react';

interface CarouselControlsProps {
    children: ReactNode;
    className?: string;
}

export function CarouselControls({ children, className }: CarouselControlsProps) {
    return (
        <div className={cn('flex items-center justify-center md:justify-between', className)}>
            {children}
        </div>
    );
}
